import { useState } from "react";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { api } from "src/shared/setup/API/api";

export const UseFormGraphicProduction = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { filterGraphicProduction, setDataGraphicProduction } = useMetricsContext();

  const [loading, setLoading] = useState(false);

  const handleCreatePerfilAcesso = async () => {
    if (!filterGraphicProduction.start_date)
      return handleGetAlert({ message: `Escolha uma data inicial !` });
    if (!filterGraphicProduction.end_date)
      return handleGetAlert({ message: `Escolha uma data final !` });

    setLoading(true);

    return api
      .get(`/metrics/producao-graphic?start_date=${filterGraphicProduction.start_date}&end_date=${filterGraphicProduction.end_date}&interval=${filterGraphicProduction.interval}`)
      .then((res) => {
        setDataGraphicProduction(res.data);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleSubmit: handleCreatePerfilAcesso, loading };
};
